import React from "react";

export default class WebCnCard extends React.Component {
  render() {
    const { Bs, VARIANT, dataCN } = this.props;
    return (
      <>
        {dataCN && (
          <Bs col xs={12} md={6} lg={6} className="mb-4 align-item-center">
            <Bs row className="mb-2">
              <Bs b>Zákazník</Bs>
            </Bs>
            {dataCN[0]?.InvoiceICO && (
              <Bs row>
                <Bs small>(IČO: {dataCN[0]?.InvoiceICO})</Bs>
              </Bs>
            )}
            <Bs row>
              <Bs small>{dataCN[0]?.InvoiceName}</Bs>
            </Bs>
            <Bs row>
              <Bs small>{dataCN[0]?.InvoiceStreet}</Bs>
            </Bs>
            <Bs row>
              <Bs small>
                {dataCN[0]?.InvoiceCity}, {dataCN[0]?.InvoiceCountry}
              </Bs>
            </Bs>
          </Bs>
        )}
      </>
    );
  }
}
